import {
  dealerService
}
from '../services';

import PrepareFilter from '../utils/PrepareFilter';
import config from '../Config';

const state = {
  status: {},
  dealer: [],
  address: null,
  distance: 100,
  filter: 0,
  country: 'DE',
  searchstring: null,
  showOffers: true,
  vehiclesCount: -1,
  bookmarks: [],
  bookmarkedVehicles: [],
  vehicleOffers: [],
  lastUrlQuery: "",
  vehicle: null,
  distanceOptions: [10, 20, 50, 100, 200, 500],
  locationVehicleListScrollPosition: 0,
  dealerVehicleListScrollPosition: 0,
  countrys: [{
    name: "Deutschland",
    value: "DE"
  }, {
    name: "Frankreich",
    value: "FR"
  }, {
    name: "Italien",
    value: "IT"
  }, {
    name: "Kanada",
    value: "CA"
  }, {
    name: "Luxemburg",
    value: "LU"
  }, {
    name: "Niederlande",
    value: "NL"
  }, {
    name: "Schweiz",
    value: "CH"
  }, {
    name: "Vereinigte Staaten",
    value: "US"
  }, {
    name: "Vereinigtes Königreich",
    value: "UK"
  }, {
    name: "Österreich",
    value: "AT"
  }]
};

const actions = {

  async dealerByLocation(state, opt) {

      await dealerService.getDealerByLocation(opt.lat, opt.lng, opt.limit,
          opt.filter)
        .then(
          data => {
            if (!data) {
              this.commit('availableVehiclesCountFailure');
            } else {
              this.commit('summery/dealerByLocationSuccess', data);
            }
          },
          error => {
            this.dispatch('summery/error', error, {
              root: true
            });
          }
        );

      return true
    },
    async fetchVehicle(state, uid) {

      await vehiclesService.fetchVehicle(uid)
        .then(
          async data => {
            if (!data) {
              this.commit('availableVehiclesCountFailure');
            } else {

              let d = data[0];

              if (d) {
                let images = await mapImages(d.images);

                d.images = images;
              }

              this.commit('summery/fetchedVehicleSuccess', d);
            }
          },
          error => {
            this.dispatch('summery/error', error, {
              root: true
            });
          }
        );

      return true
    },
    async error(state, error) {
      console.log("Error");

    }
};

function mapImages(i) {
  return Promise.all(i.map((image) => {
    return {
      src: config.filedelivery + image,
      org: image
    };
  }));
}
const mutations = {
  async dealerByLocationSuccess(state, dealer) {
      console.log(dealer);
      state.dealer = dealer;
    },
    address(state, address) {
      console.log("ADEE", address)
      state.address = address
    },
    filter(state, filter) {
      console.log("ADEE", filter)
      state.filter = filter
    },
    availableVehiclesCountFailure(state) {
      state.vehiclesCount = -1;
    }
};

const getters = {}

export const summery = {
  namespaced: true,
  state,
  actions,
  mutations
};
